import axios from 'axios'
import KJUR from "jsrsasign";
import { getRandomString, encryptData, decryptData } from './encrypt'
/** 文件下载超时 */
const FILE_TIME_OUT = 60 * 1000
/** api请求超时时间 */
const TIME_OUT = 15 * 1000

const useEncrypt = process.env.NODE_ENV !== 'development'
// const useEncrypt = true
// const useEncrypt = false
const aes_key = getRandomString(16)
let api_param_cfg = {}
let api_host = process.env.VUE_APP_API_HOST
export function setApi_host(path) {
  api_host = path
}
/** 读取本地文件 */
export function readStaticFile(path) {
  return axios.get(path).then((response) => {
    response.success = response.status === 200
    if (!response.success) {
      return Promise.reject(response.status)
    } else {
      return response
    }
  })
}
/**
 * 请求实现
 * @param {*} method GET/POST
 * @param {*} header 头信息
 * @param {*} url 完整地址
 * @param {*} data 参数
 * @param {*} params 额外辅助参数 {timeout,}
 */
const r_header = {
  'Content-Type': 'application/json;charset=UTF-8',
  'Access-Control-Allow-Origin': '*',
  // Authorization: Authorization,
  // "X-Client-Identity": P_User.getXClientIdentity(),
  // "X-Client-TimeStamp": getTimeSecond(true),
  'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
  'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
}

// const baseUrl = 'http://coin.saas-xy.com:82'
// const baseUrl =  'http://192.168.2.36:8228'
// const baseUrl =  'http://192.168.3.5:8228'

export function apiRequest(config, params) {
  console.log(config,'configprocess.env.VUE_APP_GUIDE_HOST',process.env.VUE_APP_API_HOST)
  const isPc = config.url.indexOf('/api/xy') !== -1
  console.log('apiRequest', '===>', 'PC端接口不做加密', isPc)
  if (useEncrypt && config.method == 'post' && config.url !== '/customer/user/file/upload' && !isPc) {
    api_param_cfg = { key: aes_key, url: config.url }
    const en_r_data = encryptData(config.data, api_param_cfg)
    config.data = en_r_data || config.data
  }

  // 处理token
  return new Promise((resolve, reject) => {
    const { timeout = TIME_OUT } = params || {}
    const _instance = instance()
    config.headers=r_header
    setHeaderToken(config.headers)
    config.timeout = timeout
    config.url = api_host + config.url
    _instance
      .request(config)
      .then((response) => {
        if (response) {
          if (response.status !== 200) {
            // reject({code,msg})
          } else {
            const res = response.data
            if (response.data.code === '0000') {
              // 登录需要响应头
              // if (response.config.url == '/didi/app/customer/login') {
              //   resolve(response)
              // }
              // 解密处理
              if (response.headers['x-server-encrypt'] == '1') {
                try {
                  const resData = decryptData(res.data, api_param_cfg)
                  res.data = resData
                  // 当时文件上传时 需要截取域名
                  console.log('response', response)
                  resolve(res)
                } catch (error) {
                  return 'err'
                }
              } else {
                if (response.config.url == '/customer/user/file/upload') {
                  var url = res.data.url
                  var arrUrl = url.split('//')

                  var start = arrUrl[1].indexOf('/')
                  var relUrl = arrUrl[1].substring(start) //stop省略，截取从start开始到结尾的所有字符

                  res.data.url = relUrl
                }
                resolve(response.data)
              }
            }
			 else {
              reject(response.data)
            }
          }
        } else {
        }
      })
      .catch((err) => {
          //处理错误信息
        // Toast.fail('网络错误，请联系管理员')
        return reject(err.response.data)
      })
  })
}
/**
 * 文件下载
 * @param {*} url 地址
 * @param {*} params {headers:头文件,try_count:失败重试次数}
 * @returns
 */
export function downFile(url, params) {
  return new Promise((resolve, reject) => {
    const { headers, try_count = 0, onDownloadProgress } = params || {}
    const request = (_try_count) => {
      axios({
        url,
        method: 'get',
        headers,
        data: {},
        timeout: FILE_TIME_OUT,
        onDownloadProgress: onDownloadProgress
      })
        .then((response) => {
          if (response.status === 200) {
            resolve(response)
          } else {
            reject({
              code: response.status,
              error: response.statusText
            })
          }
        })
        .catch((err) => {
          if (_try_count > 0) {
            setTimeout(() => {
              request(_try_count - 1)
            }, 3000)
          } else {
            reject({
              code: '0-0001',
              error: err.message
            })
          }
        })
    }
    request(try_count)
  })
}
function setHeaderToken (config) {
  const header = { alg: 'HS512', typ: 'JWT' };
  const secretKey = "clientAccess_xysfkhdfw";
    const payload = {
      //当前 clientCode写死，平台配置固定saas
      clientCode: 'saas',
      grantCode: process.env.VUE_APP_GRANT_CODE||'DozXyxfgaP-e',
      identity: 'admin',
      exp: Math.floor(Date.now() / 1000) + 120 - Number(localStorage.getItem('timeCheck'))
    };
    const token = KJUR.jws.JWS.sign('HS512', header, payload, secretKey);
    delete config.Authorization
    config['ClientAuthorization'] = token //携带权限参数
}

/**
 * 创建axios
 */
var axios_instance = {}
function instance(key) {
  if (!axios_instance[key]) {
    axios_instance[key] = axios.create({
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json;charset=UTF-8'
        // "Access-Control-Allow-Origin":"*",
      },
      adapter: false ? require('./xhr') : undefined
    })
  }
  return axios_instance[key]
}

var error_list = {}
function getErrorText(_errCode) {
  if (!error_list) {
    error_list = {
      // [200]: '服务器成功返回请求的数据。',
      // [201]: '新建或修改数据成功。',
      // [202]: '一个请求已经进入后台排队（异步任务）。',
      // [204]: '删除数据成功。',
    }
  }
  return error_list[_errCode]
}
/**
 * 获取错误码
 * @param {*} error
 */
function getErrMsg(error) {
  //通过error处理错误码
  if (!error.response) {
    //无网络时单独处理
  }

  const errCode = error.response.status //错误码
  const errMsg = getErrorText(errCode) //错误消息

  return { code: errCode, msg: errMsg ? `${errMsg} [${errCode}]` : error.message }
}

function isNotoken(url) {
  const _url = url || ''
  return _url.indexOf('captchaCode') !== -1 ||  _url.indexOf('sysConfig') !== -1
}